export const TIP_USER_EXISTED_ERROR_CODE = 'error_user_not_found'

export enum DepositRewardEnum {
  Percent,
  Cash,
  FreeSpin,
}
